import {
    Component,
    OnInit,
    Output,
    Input,
    ViewChild,
    EventEmitter,
    TemplateRef,
    ElementRef
} from '@angular/core';
import {
    Observable
} from "rxjs";
import {
  ClrCombobox,
} from "@clr/angular";
import {ComboboxSelectionItem, DuckDbDashboardData, InfrastructureVersion} from "@app/netscope/model/data-models";
import {NetscopeUiService} from "@app/services/netscope-ui.service";
import {infrastructure} from "@cds/core/demo/data/infrastructure.data";

@Component({
    standalone: false,
    selector: 'selection-combobox',
    templateUrl: './selection-combobox.component.html',
    styleUrls: ['./selection-combobox.component.css'],
    // imports: [ClarityModule, ClrComboboxModule, AsyncPipe]
})
export class SelectionComboboxComponent implements OnInit {

    loadingResources = false;
    asyncResources$: Observable <any> ;

    selectedItemsValue: ComboboxSelectionItem[] = [];
    comboboxOptionsAreVisible: Boolean = false;
    comboboxIsActive: Boolean = false;
    dashboardData: DuckDbDashboardData;

    @Input()
    get selectedItems() {
        return this.selectedItemsValue;
    }

    @Output()
    selectedItemsChange = new EventEmitter();

    set selectedItems(val) {

        if (val == undefined) {
            val = [];
        }

        this.selectedItemsValue = val;
        this.selectedItemsChange.emit(this.selectedItemsValue);
        this.comboboxOptionsAreVisible = false;

        // Execute this block 100ms later to give the time of the event to propagate
        setTimeout(() => {
            if (this.resourceComboBox != undefined) {
                this.resourceComboBox.searchText = "";
                this.resourceComboBox.focused = false;
                this.resourceComboBox.textbox.nativeElement.blur();
            }
        }, 100);
    }

    @Output()
    onChange: EventEmitter < any > = new EventEmitter();

    @Input()
    itemsGenerator: (...args) => void;

    @Input()
    templateSelectedItems: TemplateRef < any > ;

    @Input()
    templateDisplayItems: TemplateRef < any > ;

    @Input()
    templateDisplayWhenEmpty: TemplateRef < any > ;

    @Input()
    templateDisplayWhenErrors: TemplateRef < any > ;

    @Input()
    itemsField: string;

    disabledCounters = {
        resource: false
    };

    @ViewChild('resourceComboBox') resourceComboBox: ClrCombobox < string > ;

    constructor(private netscopeUiService: NetscopeUiService) {}

    ngOnInit(): void {
      const dashboardDataObservable = this.netscopeUiService.duckDbDataSubject
      dashboardDataObservable.subscribe((dashboardData: DuckDbDashboardData) => {
        this.dashboardData = dashboardData;
        this.fixNames();
      });
    }

    fixNames = () => {
      if (this.dashboardData != undefined && this.selectedItems.length > 0) {
        for (let item of this.selectedItems) {
          if (item.resource.name == undefined && this.dashboardData.flowsRepository.duckDbNodeMapping.has(item.resource.uuid)) {
            item.resource.name = this.dashboardData.flowsRepository.duckDbNodeMapping.get(item.resource.uuid).name;
          }
        }
      }
    }

    clickComboBox = (childElement, combo: any) => {
        this.sendArrowDown();
    }

    sendArrowDown = () => {
        const event = new KeyboardEvent('keydown', {
            key: "ArrowDown"
        });
        this.comboboxOptionsAreVisible = true;
        this.resourceComboBox.textbox.nativeElement.dispatchEvent(event);
    }

    _focus = () => {
        console.log("_focus()");
        this.itemsGenerator();
    }

    _clrInputChange = (event) => {
        console.log(`_clrInputChange(${event})`);
        if (this.comboboxIsActive) {
            return this.itemsGenerator(event, this);
        } else {
            return null;
        }
    }

    _clrOpenChange = (event) => {
        console.log(`_clrOpenChange(${event})`);
        this.comboboxIsActive = event;
        let result = null;
        if (this.comboboxIsActive) {
            this.clickComboBox(this.resourceComboBox, this);
            result = this.itemsGenerator('', this)
        }
        return result;
    }

    _click = (resourceComboBox) => {
        console.log("_click()");
        this.clickComboBox(resourceComboBox, this);
    }

    _clrSelectionChange = (event) => {
        if (event.model !== null && event.model !== undefined && event.model.length > 1) {
            event.model = [event.model[event.model.length - 1]];
        }

        console.log(`_clrSelectionChange(${event})`);

        this.onChange.emit(event);
    }

}
